<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getContracts()
      vm.getPaymentdetails2s()
      vm.getPaymentdetails2sDelinquent_month()
      vm.getPaymentdetails2sDelinquent_two_month()
      vm.getCompanies()
      vm.getOffices()
    })
  },
  methods: {
    // getContracts () {
    //   this.$store.dispatch('getContracts')
    // },

    getPaymentdetails2s () {
      this.$store.dispatch('getPaymentdetails2s')
    },

    getPaymentdetails2sDelinquent_month () {
      this.$store.dispatch('getPaymentdetails2sDelinquent_month')
    },

    getPaymentdetails2sDelinquent_two_month () {
      this.$store.dispatch('getPaymentdetails2sDelinquent_two_month')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Paymentdetails2s.vue?346cb6c6